import styled from "styled-components";

export const StyledSection = styled.section`
  @media ${({ theme }) => theme.media.mobile} {
    display: flex;
    flex-direction: column;
  }
`;
